import AllImagesIconDark from 'assets/images/icons/dark - image.svg?react';
import AllImagesIconSimpleFiligree from 'assets/images/icons/simple filigree - image.svg?react';
import AllImagesIconSpringVibes from 'assets/images/icons/spring - image.svg?react';
import AllImagesIconVickyBaumannBoho from 'assets/images/icons/vicky boho - image.svg?react';
import AllImagesIconVickyBaumannFineart from 'assets/images/icons/vicky fineart - image.svg?react';
import { IIconProps } from 'types/icons';
import { BaseIcon } from './BaseIcon';
import { SetIcon } from './SetIcon';
import { useTemplateVariant } from 'hooks/useTemplateVariant';

const LegacyImageIcon = (props: IIconProps) =>
  useTemplateVariant({
    classic: () => <BaseIcon icon={AllImagesIconSimpleFiligree} {...props} />,
    dark: () => <BaseIcon icon={AllImagesIconDark} {...props} />,
    simpleFiligree: () => <BaseIcon icon={AllImagesIconSimpleFiligree} {...props} />,
    springVibes: () => <BaseIcon icon={AllImagesIconSpringVibes} {...props} />,
    vickyBaumannBoho: () => <BaseIcon icon={AllImagesIconVickyBaumannBoho} {...props} />,
    vickyBaumannFineart: () => <BaseIcon icon={AllImagesIconVickyBaumannFineart} {...props} />,
    breeze: () => <BaseIcon icon={AllImagesIconSimpleFiligree} {...props} />,
    capri: () => <BaseIcon icon={AllImagesIconSimpleFiligree} {...props} />,
    rose: () => <BaseIcon icon={AllImagesIconSimpleFiligree} {...props} />,
    calm: () => <BaseIcon icon={AllImagesIconSimpleFiligree} {...props} />
  })();

export const ImageIcon = (props: IIconProps) => (
  <SetIcon slug="image" fallback={LegacyImageIcon} {...props} />
);
